import { DamzContext } from '@wix/da-react-context/pkg/DamzContext';
import React, { useContext } from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';

export interface Props {}

const DamzInit: React.FC<Props> = () => {
  const { GlobalComponent } = useContext(DamzContext);
  const isMounted = useIsMounted();

  // Must have dep, feature, and not be SSR
  if (!GlobalComponent || !isMounted) {
    return null;
  }

  return <GlobalComponent />;
};
DamzInit.displayName = 'DamzInit';

export default DamzInit;
